import { Clock } from "lucide-react";

const OPTIONS = [];
for (let h = 5; h <= 21; h++) for (const m of [0, 15, 30, 45]) { if (h === 21 && m > 0) break; OPTIONS.push(`${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`); }

export const fmt12 = (t) => { if (!t) return ""; const [h, m] = t.split(":").map(Number); return `${(h % 12) || 12}:${String(m).padStart(2, "0")}${h < 12 ? "am" : "pm"}`; };
export const hoursBetween = (s, f) => { if (!s || !f) return 0; const [sh, sm] = s.split(":").map(Number); const [fh, fm] = f.split(":").map(Number); return Math.round(((fh * 60 + fm) - (sh * 60 + sm)) / 15) / 4; };

function TimeSelect({ label, value, onChange, testid, min }) {
  return (
    <label className="block">
      <span className="form-label !mb-0">{label}</span>
      <div className="relative mt-1">
        <Clock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#FF6A00] pointer-events-none" />
        <select value={value || ""} onChange={(e) => onChange(e.target.value)} className="w-full appearance-none bg-black border border-white/15 pl-9 pr-8 py-3 text-base text-white font-mono-data focus:outline-none focus:border-[#FF6A00]" data-testid={testid}>
          <option value="" disabled>Pick a time</option>
          {OPTIONS.map((t) => <option key={t} value={t} disabled={min ? t <= min : false}>{fmt12(t)}</option>)}
        </select>
        <span className="absolute right-3 top-1/2 -translate-y-1/2 text-zinc-500 text-xs pointer-events-none">▾</span>
      </div>
    </label>
  );
}

export default function TimeRangePicker({ start, finish, onChange, minHours = 4, testid = "time-range" }) {
  const hrs = hoursBetween(start, finish);
  const bad = start && finish && hrs < minHours;
  return (
    <div data-testid={testid}>
      <div className="grid grid-cols-2 gap-3">
        <TimeSelect label="Start time" value={start} onChange={(v) => onChange({ start: v, finish })} testid={`${testid}-start`} />
        <TimeSelect label="Finish time" value={finish} onChange={(v) => onChange({ start, finish: v })} testid={`${testid}-finish`} min={start} />
      </div>
      <div className={`mt-2 text-xs font-mono-data ${bad ? "text-red-400" : "text-zinc-400"}`} data-testid={`${testid}-summary`}>
        {start && finish ? (bad ? `${hrs}h selected — minimum ${minHours}h` : `${fmt12(start)}–${fmt12(finish)} · ${hrs}h`) : "Select start and finish — hours are worked out for you"}
      </div>
    </div>
  );
}
